module.exports = __webpack_public_path__ + "media/images/varta/VARTA_Promotive_EFB_470x520-ce9e5788041cde165b591de57093c13c.png";